import { Contact } from './../../models/contact';
import { ContactService } from './../../services/contact.service.';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  contact:Contact=new Contact();
  startDate :Date=new Date();
  constructor(private contactService:ContactService) { }

  ngOnInit() {
  }
  sendContact(){
    var endDate   = new Date();
    var seconds = (endDate.getTime() - this.startDate.getTime()) / 1000;
    if(seconds<5)
      {window.location.reload();return;}
    if(!this.contact.checkData()){
      Swal.fire("Eksik Bilgi", "Lütfen Eksik Kısım Bırakmayınız.", 'warning')
      return;
    }

    this.contactService.saveContact(this.contact).then((res)=>{
      this.contact=new Contact();
      Swal.fire("İşlem Başarılı", "Mesajınız başarılı bir şekilde alınmıştır. En kısa sürede size ulaşacağız.", 'success')
    }).catch((err)=>{
      Swal.fire("İşlem Hatası", "İnternet kaynaklı bir sorun ile karşılaşıldı. Lütfen tekrar deneyin veya telefon üzerinden iletişme geçiniz.", 'error')
    })
  }

}
